import { Card, CardContent, Link, Skeleton, Typography } from "@mui/material";
import { randomFloat } from "../utilities/index.js";
import React from "react";
export const RetailerCard = ({ retailer }) => (React.createElement(Card, { component: "li", sx: { backgroundColor: "white" }, variant: "elevation" },
    React.createElement(CardContent, null,
        React.createElement(Typography, { component: "h3", variant: "h5" }, retailer.name),
        React.createElement(Typography, { variant: "body2", component: "p" },
            retailer.address.street,
            ", ",
            retailer.address.postalCode,
            " ",
            retailer.address.city),
        retailer.url && (React.createElement(Typography, { variant: "body2", component: "p" },
            React.createElement(Link, { href: retailer.url }, retailer.url))))));
export const ThaliaCard = () => (React.createElement(Card, { component: "li", sx: { backgroundColor: "white" }, variant: "elevation" },
    React.createElement(CardContent, null,
        React.createElement(Typography, { component: "h3", variant: "h5" }, "Thalia Filialen"),
        React.createElement(Typography, { variant: "body2", component: "p" },
            "Unsere Krimidinner sind in allen",
            " ",
            React.createElement(Link, { href: "https://www.thalia.de/shop/home/filialen/" }, "Thalia Filialen"),
            " erh\u00E4ltlich."))));
export const RetailerCardSkeleton = () => (React.createElement(Card, { component: "li", sx: { backgroundColor: "white" }, variant: "elevation" },
    React.createElement(CardContent, null,
        React.createElement(Typography, { component: "h3", variant: "h5" },
            React.createElement(Skeleton, { sx: { width: `${randomFloat(18, 32)}ch` }, variant: "text" })),
        React.createElement(Typography, { variant: "body2", component: "p" },
            React.createElement(Skeleton, { sx: { width: `${randomFloat(34, 52)}ch` }, variant: "text" })),
        React.createElement(Typography, { variant: "body2", component: "p" },
            React.createElement(Skeleton, { sx: { width: `${randomFloat(10, 32)}ch` }, variant: "text" })))));
//# sourceMappingURL=retailer-card.js.map